module.exports = __webpack_public_path__ + "images/station-icon.d002d3c19f3124e3baae64777e870c73.png";